import { render, staticRenderFns } from "./DeferralRate.vue?vue&type=template&id=28651587&"
import script from "./DeferralRate.vue?vue&type=script&lang=js&"
export * from "./DeferralRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports